<template>
  <div class="list-container">
    <div v-show="!dengjiVisible">
      <div class="filter-container">
        <template v-if="!isFilterCollapse">
          <div class="filter-box">
            <span class="label">业务编号</span>
            <el-input
              v-model="listQuery.businessNo"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
              @keyup.enter="handleFilter"
            />
          </div>
          <div class="filter-box">
            <span class="label">业务名称</span>
            <el-input
              v-model="listQuery.businessName"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
              @keyup.enter="handleFilter"
            />
          </div>
          <div class="filter-box">
            <span class="label">外包商</span>
            <el-input
              v-model="listQuery.outsourceCompany"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
              @keyup.enter="handleFilter"
            />
          </div>
          <div class="filter-box">
            <span class="label">业务代表</span>
            <el-select :filterable="true" v-model="listQuery.salesManId" class="filter-item" placeholder="" clearable :size="t('table.btnSize')" @focus="handleSalesManFocus" @change="handleFilter">
              <el-option
                v-for="item in salesManOption"
                :key="item.id"
                :label="item.mark"
                :value="item.id"
              />
            </el-select>
          </div>
          <div class="filter-box">
            <span class="label">订单号码</span>
            <el-input
              v-model="listQuery.customerOrderNo"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
              @keyup.enter="handleFilter"
            />
          </div>
          <div class="filter-box">
            <span class="label">开始日期</span>
            <el-date-picker
              v-model="listQuery.startTime"
              type="date"
              placeholder=" "
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD"
              @change="handleFilter"
              :size="t('table.btnSize')"
            />
          </div>
          <div class="filter-box">
            <span class="label">到</span>
            <el-date-picker
              v-model="listQuery.endTime"
              type="date"
              placeholder=" "
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD"
              @change="handleFilter"
              :size="t('table.btnSize')"
            />
          </div>
          <div class="filter-box">
            <el-radio-group v-model="listQuery.invoiceStatus" @change="handleFilter">
              <el-radio label="0">未收票</el-radio>
              <el-radio label="2">部分收票</el-radio>
              <el-radio label="3">已收票</el-radio>
              <el-radio label="">全部</el-radio>
            </el-radio-group>
          </div>
        </template>
        <div class="filter-box">
          <el-button
            v-waves
            class="filter-item "
            type="primary"
            :size="t('table.btnSize')"
            @click="handleFilter"
          >
            {{ t("table.search") }}
          </el-button>
          <el-button
            v-permission="{ pkey: `${permissionName}_DJ` }"
            class="filter-item"
            type="primary"
            :size="t('table.btnSize')"
            @click="handleCommand('batch-dengji')"
          >
            批量登记
          </el-button>
          <el-button
            v-waves
            class="filter-item"
            :size="t('table.btnSize')"
            @click="handleReset"
          >
            {{ t("table.reset") }}
          </el-button>
          <el-button
            v-waves
            class="filter-item"
            :size="t('table.btnSize')"
            @click="isFilterCollapse = !isFilterCollapse"
          >
            {{ isFilterCollapse ? '展开' : '收起' }}
          </el-button>
          <span class="svg-icon cursor mr-10 ml-10" @click="handleCommand('refresh')">
            <i class="icon-tubiao-27 iconfont"/>
          </span>
          <span class="svg-icon cursor" @click="handleCommand('column')">
            <i class="icon-tubiao-28 iconfont"/>
          </span>
          <span class="ml-10 filter-mark">
            <span class="status-item"><span class="status-square" style="background-color: red;"></span><span class="status-text">需要收票</span></span>
          </span>
        </div>
      </div>
      <TableList
        ref="tableDataRef"
        v-loading="listLoading"
        :dataList="list"
        :total="total"
        :columnAllData="columnAllData"
        :tableName="TableName"
        :permissionName="permissionName"
        :tableRowClassName="tableRowClassName"
        :handleDefaultWidth="120"
        :showSelection="true"
        :showSummary="true"
        @command-change="handleCommand"
      >
        <template v-slot:operation-action="scope">
          <el-link
            v-if="scope.row.no == null && scope.row.status !== '已退款'"
            v-permission="{ pkey: `${permissionName}_DJ` }"
            href="javascript:void(0);"
            class="mr-10"
            type="primary"
            @click="handleCommand('dengji', scope.row)"
          >
            登记
          </el-link>
          <el-link
            v-if="scope.row.no"
            v-permission="{ pkey: `${permissionName}_CANCEL_TICKET` }"
            href="javascript:void(0);"
            class="mr-10"
            type="primary"
            @click="handleCommand('cancel-ticket', scope.row)"
          >
            作废
          </el-link>
          <el-link
            v-if="scope.row.no"
            v-permission="{ pkey: `${permissionName}_CANCEL_TICKET` }"
            href="javascript:void(0);"
            type="warning"
            @click="handleCommand('return-ticket', scope.row)"
          >
            退票
          </el-link>
        </template>
      </TableList>
    </div>

    <el-dialog
      v-if="dengjiVisible"
      v-model="dengjiVisible"
      width="80%"
      title="登记发票"
    >
      <div class="form-title mb-10">
        <span class="label blue">业</span>
        <span class="left">业务信息</span>
      </div>
      <MiniBusinessList :businessList="selectionRowList">
        <template v-slot:before>
          <el-table-column prop="businessNo" label="业务编号" width="100" show-overflow-tooltip/>
          <el-table-column prop="fee" label="总费用" show-overflow-tooltip width="100" align="right">
            <template #default="{ row }">
              {{ $currency(row.fee) }}
            </template>
          </el-table-column>
          <el-table-column prop="rate" label="税率" show-overflow-tooltip width="60">
            <template #default="{ row }">
              {{ row.rate }}%
            </template>
          </el-table-column>
          <el-table-column prop="invoiceStatus" label="开票状态" show-overflow-tooltip width="90"/>
          <el-table-column prop="outsourceCompany" label="外包公司" show-overflow-tooltip width="100"/>
          <el-table-column prop="accountAlias" label="账户信息" show-overflow-tooltip width="100"/>
        </template>
        <template v-slot:after>
          <el-table-column prop="amount" label="数量" width="80"/>
          <el-table-column prop="businessName" label="业务名称" width="100" show-overflow-tooltip/>
          <el-table-column prop="businessBrand" label="业务品牌" width="100" show-overflow-tooltip/>
          <el-table-column prop="businessModel" label="型号" show-overflow-tooltip/>
          <el-table-column prop="businessUnit" label="单位"/>
          <el-table-column prop="businessSerial" label="序列号" show-overflow-tooltip/>
          <el-table-column prop="outCost" label="外包费成本" width="120" align="right">
            <template #default="{ row }">
              {{ $currency(row.business.outCost)}}
            </template>
          </el-table-column>
        </template>
      </MiniBusinessList>

      <div class="form-title mt-30 mb-10">
        <span class="label green">登</span>
        <span class="left">登记发票</span>
      </div>
      <el-form
        ref="dataForm"
        :model="ruleForm"
        :rules="rules"
        label-position="top"
        label-width="100px"
        class="mb-20"
      >
        <el-form-item label="扫码抢" prop="invoiceNumber">
          <el-input v-model="ruleForm.invoiceNumber" type="textarea" class="filter-item" @keyup.enter="handleBarCodeChange" style="width:700px"></el-input>
        </el-form-item>
        <div class="underlineForm">
          <el-form-item label="发票号码" prop="no">
            <el-input v-model="ruleForm.no" type="input" class="filter-item" placeholder=" "></el-input>
          </el-form-item>
          <el-form-item label="发票代码" prop="code">
            <el-input v-model="ruleForm.code" type="input" class="filter-item" placeholder=" "></el-input>
          </el-form-item>
          <el-form-item label="发票校验码" prop="checkCode">
            <el-input v-model="ruleForm.checkCode" type="input" class="filter-item" placeholder=" "></el-input>
          </el-form-item>
          <el-form-item label="发票金额" prop="amount">
            <el-input v-model="ruleForm.amount" type="input" class="filter-item" placeholder=" "></el-input>
          </el-form-item>
          <el-form-item label="开票日期" prop="date">
            <el-date-picker
              v-model="ruleForm.date"
              type="date"
              placeholder=" "
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD">
            </el-date-picker>
          </el-form-item>
        </div>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dengjiVisible = false" type="danger">取消</el-button>
          <el-button type="primary" @click="handleDJ" >确定</el-button>
        </span>
      </template>
    </el-dialog>

    <el-dialog
      v-if="returnVisible"
      v-model="returnVisible"
      title="外包发票退票"
      width="420px"
    >
      <el-form :model="returnForm" label-position="top">
        <el-form-item label="发票信息">
          <div>发票号码：{{ activeRow.no }} ｜ 原发票金额：¥{{ activeRow.amount }}<span v-if="Number(activeRow.returnAmount || 0) > 0"> ｜ 已退金额：¥{{ activeRow.returnAmount }}</span></div>
        </el-form-item>
        <el-form-item label="本次退票金额（全额退票将释放该发票关联）">
          <el-input-number
            v-model="returnForm.amount"
            :min="0.01"
            :max="Number((Number(activeRow.amount || 0) - Number(activeRow.returnAmount || 0)).toFixed(2))"
            :precision="2"
            controls-position="right"
            style="width: 100%"
          />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="returnVisible = false">取消</el-button>
        <el-button type="primary" @click="submitReturnTicket">确定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script lang='ts'>
import { defineComponent, reactive, toRefs, onMounted, unref, nextTick, ref } from 'vue'
import { ElMessage, ElMessageBox, ElForm } from 'element-plus'
import { deleteById } from '@/apis/Dictionary'
import { getPageList as getUrlList } from '@/apis/Form'
import { cancelTicket, dengjiTicket, ticketReturn, getOutsourceFeePage } from '@/apis/OutsourceFee'
import { UsersModel } from '@/model/userModel'
import { ArrayRowsItem } from '@/model/Index'
import TableList from '@/components/common/TableList.vue'
import { TableName, permissionName } from '@/utils/enum'
import { TableField } from './FieldTable'
import { useI18n } from 'vue-i18n'
import { defaultDate, Today, pageVo, pageSizes } from '@/utils/index'
// import AccountPreview from '@/views/business/outsourceCompany/AccountPreview/Index.vue'
import MiniBusinessList from '@/views/business/businessList/MiniBusinessList.vue'

import mixins from '@/mixins'

export default defineComponent({
  name: 'Outsourcefeeticket',
  components: {
    // FormComponent,
    TableList,
    // AccountPreview,
    MiniBusinessList
    // TraceInfo,
    // BusinessInfo
  },
  setup() {
    const { t } = useI18n()
    const dataForm = ref(ElForm)
    const tableDataRef = ref(null)

    const dataMap = reactive({
      TableName: TableName.TABLE_OUTSOURCE_BUSINESS_FEE_TICKET,
      permissionName: permissionName.OUTSOURCE_BUSINESS_FEE,
      columnAllData: TableField,
      isFilterCollapse: false,

      activeId: 0,
      activeRate: 0,
      activeRow: {} as any,
      list: [],
      total: 0,
      listLoading: false,
      listQuery: {
        businessNo: undefined,
        businessName: undefined,
        businessModel: undefined,
        outsourceCompany: undefined,
        salesManId: undefined,
        invoiceStatus: undefined,
        customerOrderNo: undefined,
        startTime: '',
        endTime: '',
        ...pageVo
      },
      dialogFormVisible: false,
      statusOption: [],
      salesManOption: [],
      selectionArray: [],
      selectionRowList: [],

      pageSizes,
      layouts: [
        { x: 0, y: 0, w: 12, h: 6, i: '0', maxW: 12, minW: 12, minH: 1 }
      ],
      tabList: [
        { name: '业务信息', id: 2 },
        { name: '跟踪信息', id: 3 }
      ],
      newHpx: 0,
      activeTab: 2,
      dengjiVisible: false,
      djInfoVisible: false,
      returnVisible: false,
      returnForm: {
        amount: 0
      },
      DJTableData: [],
      paymentAccountOption: [],
      ruleForm: {
        invoiceNumber: '',
        no: '',
        code: '',
        checkCode: '',
        amount: 0,
        date: Today
      },
      rules: {
        invoiceNumber: [{ required: false, message: '请填写必填项', trigger: 'change' }],
        no: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        code: [{ required: false, message: '请填写必填项', trigger: 'change' }],
        amount: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        checkCode: [{ required: false, message: '请填写必填项', trigger: 'change' }],
        date: [{ required: true, message: '请填写必填项', trigger: 'change' }]
      },

      handleCommand(command: string, val?: any) {
        console.log(command, 'command')
        if (command !== 'column' && command !== 'selection') {
          dataMap.activeRow = val
          dataMap.activeId = val ? val.id : 0
        }
        switch (command) {
          case 'add':
            dataMap.handleCreate()
            break
          case 'copy':
          case 'edit':
            dataMap.handleUpdate(val)
            break
          case 'delete':
            dataMap.handleDelete(val)
            break
          case 'dengji':
            dataMap.activeRate = val.rate
            dataMap.selectionRowList = [val]
            dataMap.dengjiVisible = true
            dataMap.ruleForm = {
              invoiceNumber: '',
              no: '',
              code: '',
              checkCode: '',
              amount: val.fee,
              date: Today
            }
            break
          case 'batch-dengji':
            {
              if (!dataMap.selectionArray.length) {
                return ElMessage.error({
                  message: '请选择数据',
                  duration: 1000
                })
              }
              const firstItem = dataMap.selectionArray[0]
              let totalFee = 0

              const sameFiled = [{ key: 'outsourceCompany', name: '外包商' }, { key: 'ticketCompany', name: '所属公司' }, { key: 'rate', name: '外包税率' }, { key: 'invoiceType', name: '发票类型' }]
              for (let i = 0; i < dataMap.selectionArray.length; i++) {
                const item = dataMap.selectionArray[i]
                for (let j = 0; j < sameFiled.length; j++) {
                  const kk = sameFiled[j]
                  if (item[kk.key] !== firstItem[kk.key]) {
                    return ElMessage.error({
                      message: `请选择同一个${kk.name}业务`,
                      duration: 1000
                    })
                  }
                }
                totalFee += item.fee
              }
              dataMap.activeRate = firstItem.rate

              dataMap.ruleForm = {
                invoiceNumber: '',
                no: '',
                code: '',
                checkCode: '',
                amount: totalFee,
                date: Today
              }
              dataMap.selectionRowList = dataMap.selectionArray
              dataMap.dengjiVisible = true
            }
            break
          case 'refresh':
            dataMap.handleFilter()
            break
          case 'column':
            (tableDataRef.value as any).setColumnVisible = true
            break
          case 'current-change':
            dataMap.handleCurrentChange(val)
            break
          case 'size-change':
            dataMap.handleSizeChange(val)
            break
          case 'cancel-ticket':
            dataMap.cancelTicket(val)
            break
          case 'return-ticket':
            dataMap.activeRow = val
            dataMap.returnForm.amount = Number((Number(val.amount || 0) - Number(val.returnAmount || 0)).toFixed(2))
            dataMap.returnVisible = true
            break
          case 'selection':
            dataMap.selectionArray = val
            break
        }
      },
      getList() {
        dataMap.listLoading = true
        getOutsourceFeePage({ ...dataMap.listQuery, pageType: 2 }).then((res: any) => {
          dataMap.list = res.data
            ? res.data.map((item: any) => {
              return {
                ...item,
                customerCompany: item.business.customerCompany,
                ticketCompany: item.business.ticketCompany,
                businessNo: item.business.no,
                businessName: item.business.name,
                businessBrand: item.business.brand,
                businessAmount: item.business.amount,
                businessModel: item.business.model,
                businessSerial: item.business.serial,
                businessUnit: item.business.unit,
                accountAlias: item.account?.alias,
                orderTaxRate: item.business.orderTaxRate,
                orderFee: item.business.orderFee
              }
            })
            : []
          dataMap.total = res.total
          dataMap.listLoading = false
          dataMap.activeId = dataMap.list.length ? dataMap.list[0].id : 0
        }).catch(() => {
          dataMap.listLoading = false
        })
      },
      handleReset() {
        dataMap.listQuery = {
          businessNo: undefined,
          businessName: undefined,
          businessModel: undefined,
          outsourceCompany: undefined,
          salesManId: undefined,
          invoiceStatus: undefined,
          customerOrderNo: undefined,
          startTime: defaultDate[0],
          endTime: defaultDate[1],
          ...pageVo
        }
        dataMap.handleFilter()
      },
      handleFilter() {
        const { startTime, endTime } = dataMap.listQuery
        const tempsStart = startTime ? new Date(startTime).getTime() : 0
        const tempdEnd = endTime ? new Date(endTime).getTime() : 0
        if (!tempsStart) {
          return ElMessage.error({ message: '请选择开始时间', duration: 1000 })
        } else if (!tempdEnd) {
          return ElMessage.error({ message: '请选择结束时间', duration: 1000 })
        } else if (tempsStart > tempdEnd) {
          return ElMessage.error({ message: '开始时间必须小于结束时间', duration: 1000 })
        }
        dataMap.getList()
      },

      handleCreate() {
        dataMap.activeId = 0
        dataMap.dialogFormVisible = true
      },
      handleUpdate(row: any) {
        dataMap.activeId = row.id
        dataMap.dialogFormVisible = true
      },
      handleBarCodeChange() {
        const value = dataMap.ruleForm.invoiceNumber
        const code = value.split(',') || []
        dataMap.ruleForm.no = code[2]
        dataMap.ruleForm.code = code[3]
        dataMap.ruleForm.checkCode = code[6]
        const amount = Number(code[4])
        dataMap.ruleForm.amount = Math.floor(amount * ((Number(dataMap.activeRate) + 100) / 100))
        dataMap.ruleForm.date = `${code[5].slice(0, 4)}-${code[5].slice(4, 6)}-${code[5].slice(6, 8)}`
      },
      handleDJ() {
        const form = unref(dataForm)
        form.validate(async(valid: any) => {
          if (valid) {
            try {
              const params = {
                ...dataMap.ruleForm,
                ids: dataMap.selectionRowList.map((kk: any) => kk.id)
              }
              await dengjiTicket(params)
              dataMap.getList()
              ElMessage.success('提交成功')
              dataMap.dengjiVisible = false
            } catch (err: any) {
              console.log(err)
            }
          }
        })
      },
      submitReturnTicket() {
        ticketReturn({
          ids: [dataMap.activeRow.id],
          amount: dataMap.returnForm.amount
        }).then(() => {
          ElMessage.success('退票成功')
          dataMap.returnVisible = false
          dataMap.getList()
        })
      },
      handleDelete(row: any) {
        ElMessageBox.confirm(
          '确定要删除选中数据吗？',
          '删除',
          {
            confirmButtonText: t('table.confirm'),
            cancelButtonText: t('table.cancel'),
            type: 'warning',
            cancelButtonClass: 'el-button--danger'
          }
        )
          .then(() => {
            deleteById('invoice', row.id).then(() => {
              dataMap.getList()
              ElMessage.success('删除成功')
            })
          })
      },
      handleSubmit() {
        dataMap.getList()
      },
      handleResolveTempData(tempModel: any) {
        const { model } = tempModel
        tempModel.model = model ? model.join(',') : ''
      },
      handleCurrentChange(page?: any) {
        dataMap.listQuery.page = page
        dataMap.getList()
      },
      handleSizeChange(size: any) {
        dataMap.listQuery.size = size
        dataMap.handleCurrentChange(1)
      },
      getDropdownList() {
        getUrlList('dropdown/BusinessInvoicingStatus').then((res: any) => {
          dataMap.statusOption = res ? res.filter((k: any) => k.id !== 3) : []
        })
        getUrlList('/paymentAccount/dropdown').then((res: any) => {
          dataMap.paymentAccountOption = res || []
        })
      },
      handleSalesManFocus() {
        getUrlList('user/dropdown/salesman').then((res: any) => {
          dataMap.salesManOption = res || []
        })
      },
      handleTabClick(item: any) {
        dataMap.activeTab = item.id
      },
      handleResizedEvent(i: any, newH: any, newW: any, newHPx: any) {
        dataMap.newHpx = newHPx
      },
      handleRowClick(row: any) {
        dataMap.activeId = row.id
      },
      clearValidate() {
        nextTick(() => {
          (dataForm.value as typeof ElForm).clearValidate()
        })
      },
      cancelTicket(val: any) {
        ElMessageBox.confirm(
          '确定要作废此外包费发票？',
          '作废发票',
          {
            confirmButtonText: t('table.confirm'),
            cancelButtonText: t('table.cancel'),
            type: 'warning',
            cancelButtonClass: 'el-button--danger'
          }
        )
          .then(() => {
            cancelTicket(val.id).then(() => {
              dataMap.getList()
              ElMessage.success('作废成功')
            })
          })
      },
      tableRowClassName({ row }: any) {
        return (!row.no && row.status !== '已退款') ? 'row-red' : ''
      }
    })
    const { mixinData } = mixins(dataMap)
    onMounted(() => {
      dataMap.listQuery.startTime = defaultDate[0]
      dataMap.listQuery.endTime = defaultDate[1]
      dataMap.getList()
      dataMap.getDropdownList()
    })
    return {
      t,
      ...toRefs(dataMap),
      ...toRefs(mixinData),
      dataForm,
      tableDataRef
    }
  }
})
</script>
<style lang="scss">
</style>
